export interface NFCeConsultaDto {
  nfCeId: number;
  numeroNF: number;
  serie: number;
  codigoStatusEnvio: number;
  descricaoStatusEnvio: string;
  codigoStatusResposta: number;
  descricaoMotivoResposta: string;
  emissaoDataHora: moment.Moment;
}

export const statusEnvioOptions = [
  { value: "0", label: "Aguardando Envio" },
  { value: "1", label: "Enviada Sem Retorno" },
  { value: "2", label: "Finalizada" },
  { value: "3", label: "Finalizada Denegada" },
  { value: "99", label: "Todos" },
];

export interface NFCeConsultaInputDto {
  codigoStatusEnvio: string | null;
  dataEmissaoInicial: Date | null;
  dataEmissaoFinal: Date | null;
  serie: number | null;
}
